import { useEffect, useState } from "react";
import { Sparkles, Lock } from "lucide-react";
import { ChatPanel } from "@/components/chat/ChatPanel";
import { useLanguage } from "@/hooks/useLanguage";
import { trackEvent } from "@/lib/audit";
import type { ChatMessage } from "@/types";
import { TacticalQuickPrompts } from "@/components/communication/TacticalQuickPrompts";

interface Props {
  messages: ChatMessage[];
  onSend: (text: string) => void;
  onAiReply?: (content: string) => void;
  matchContext?: string;
}

export function PrivateAIOracle({ messages, onSend, onAiReply, matchContext }: Props) {
  const { t } = useLanguage();
  const [pendingPrompt, setPendingPrompt] = useState<string | null>(null);
  useEffect(() => {
    void trackEvent("ai_oracle_opened", {});
  }, []);
  return (
    <div className="flex h-full flex-col gap-2">
      <div className="flex items-center gap-2 rounded-xl bg-gradient-to-r from-[oklch(0.45_0.18_280)] to-[oklch(0.55_0.22_300)] px-3 py-2 text-white">
        <Sparkles className="h-4 w-4" />
        <div className="text-xs font-bold">{t("oracle_private_title")}</div>
        <Lock className="ml-auto h-3 w-3 opacity-80" />
        <span className="text-[10px] opacity-90">{t("oracle_private_badge")}</span>
      </div>
      <div className="flex-1 min-h-0">
        <ChatPanel
          messages={messages}
          onSend={(t) => {
            void trackEvent("ai_oracle_question_submitted", { len: t.length });
            void trackEvent("match_ai_question_submitted", { len: t.length });
            onSend(t);
          }}
          onAiReply={(c) => {
            void trackEvent("ai_oracle_response_generated", { len: c.length });
            onAiReply?.(c);
          }}
          matchContext={matchContext}
          prefillText={pendingPrompt ?? undefined}
          onPrefillConsumed={() => setPendingPrompt(null)}
        />
      </div>
      <TacticalQuickPrompts onPick={(text) => setPendingPrompt(text)} />
    </div>
  );
}